import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        tab: 'handleTabClick',
      }
    };
  }

  handleTabClick( ev ) {
    this.$('tab').forEach( tab => tab.setAttribute('aria-selected', 'false') );
    ev.target.setAttribute('aria-selected', 'true');

    this.$('panel').forEach( panel => panel.children[0].style.display = 'none' );
    const panelName = ev.target.getAttribute('aria-controls');
    this.el.querySelector(`[data-panel-id=${ panelName }]`).children[0].style.display = 'flex';
  }

  init() {
    //console.log( this.$('panel') );
  }
}
